/* ---------------------------------------------------------------------------
   Show the picture of the variant the customer just chose.

   The fault, 19 Sept: picking a different shape on a product whose variants each
   carry their own photograph changed the price, the title and the buy button,
   and left the gallery on the first image. On the wood pulp banneton that meant
   choosing Round creased and looking at an oval basket, which is the one thing
   a shape choice is for. It affects every product built this way: the wood pulp
   banneton, the bamboo banneton and the silicone basket.

   Not a v5 regression. The same click fails on the live 4.8 theme, so it has
   been there as long as those products have had per-variant photographs.

   Why the theme does not do it. Warehouse switches gallery images from a naming
   convention in the media ALT tag, "Some alt # Shape_Round creased", not from
   the featured image assigned to a variant in the admin. Our media is assigned
   the ordinary way, so the theme has nothing to match on and leaves the gallery
   alone. The convention could be adopted instead, but it would put "# Shape_..."
   into the alt text of every product photograph, which is read aloud by a screen
   reader, and it would have to be maintained by hand on every future upload.
   Reading the featured image the variant already has is less to remember and
   nothing to get wrong.

   The event is the theme's own. variant:changed is dispatched on the product
   form with the full variant object, featured_media included, so there is no
   need to fetch anything or to know which option changed.

   The retries are the same lesson as the cart drawer. The theme re-renders part
   of the product block after a variant change, and a class set before that pass
   finishes is thrown away. Four attempts over 400ms cost nothing and survive it.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var TRIES = [0, 80, 200, 400];

  document.addEventListener('variant:changed', onChange, true);

  function onChange(event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant || !variant.featured_media) return;

    var id = String(variant.featured_media.id);

    TRIES.forEach(function (ms) {
      setTimeout(function () { select(id); }, ms);
    });
  }

  function select(id) {
    var items = document.querySelectorAll('.product-gallery__carousel-item');
    if (!items.length) return;

    /* If the gallery does not hold this image, leave it exactly as it is. A
       half-applied state is worse than the one we are correcting. */
    var found = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-media-id') === id) { found = true; break; }
    }
    if (!found) return;

    for (var j = 0; j < items.length; j++) {
      var on = items[j].getAttribute('data-media-id') === id;
      items[j].classList.toggle('is-selected', on);
      items[j].classList.toggle('product-gallery__carousel-item--hidden', !on);
    }

    var thumbs = document.querySelectorAll('.product-gallery__thumbnail');
    for (var k = 0; k < thumbs.length; k++) {
      thumbs[k].classList.toggle('is-nav-selected', thumbs[k].getAttribute('data-media-id') === id);
    }
  }
})();
